import { createAction } from "@reduxjs/toolkit";

export const setUserInfo = createAction<string>("user/SET_USER_INFO");
export const setAccessToken = createAction<string>("user/SET_ACCESS_TOKEN");
export const signOut = createAction("user/SIGN_OUT");
